import React, { Component } from 'react';

export const Months = [
    'Janvier',
    'Fevrier',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Aout',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre'
]
export const oneDay = 24 * 60 * 60 * 1000
export const oneWeek = 7 * 24 * 60 * 60 * 1000
export const oneMonth = 30 * 24 * 60 * 60 * 1000
export const oneYear = 365 * 24 * 60 * 60 * 1000
export const firstDayOfYear = new Date(new Date().getFullYear(), 0, 1)
export const firstYear = 2020

export const yearsList = () => {
    let years = []
    let current = new Date().getFullYear()
    let diff = current - firstYear

    years.push(firstYear)
    for (let i = 1; i <= diff; i++) {
        const year = firstYear + i;
        years.push(year)
    }
    return years.reverse()
}
export const yearsListOption = () => {
    let years = []
    let current = new Date().getFullYear()
    let diff = current - firstYear

    years.push(<option>{firstYear}</option>)
    for (let i = 1; i <= diff; i++) {
        const year = firstYear + i;
        years.push(<option>{year}</option>)
    }
    return years.reverse()
}

export const sortByDate = (list, field = "date") => {
    list.sort((a, b) => {
        a = new Date(a[field]);
        b = new Date(b[field]);
        if (a > b){
            return 1;
        }
        if (a < b){
            return -1;
        }
        return 0;
    });
    return list
} 
export const groupByMonth = (list, field) => {
    let groupList = {}
    list = sortByDate(list, field)
    list.forEach( item => {
        let key = Months[new Date(item[field]).getMonth()] +" "+ new Date(item[field]).getFullYear()
        if( !groupList[key] ) {
            groupList[key] = []
        }  
        groupList[key].push(item)
    })
    return groupList
}
export const groupByDate = (list, field) => {
    let groupList = {}
    list = sortByDate(list, field)
    list.forEach( item => {
        let key = new Date(item[field]).toLocaleDateString("fr-FR")
        if( !groupList[key] ) {
            groupList[key] = []
        }  
        groupList[key].push(item)
    })
    return groupList
}
export const groupBy = (list, field) => {
    let groupList = {}
    list.forEach( item => {
        if( !groupList[item[field]] ) {
            groupList[item[field]] = []
        }  

        groupList[item[field]].push(item)
    })
    return groupList
}

export const sumList = (list, field, val) => {
    return list.reduce( (acc, obj) => {
        var key = obj[field]            
        var value = obj[val]            
        
        if(!acc[key]){
            acc[key] = 0;
        }
        acc[key] += value ;
        return acc;
    }, {});
}
export const countList = (list, field) => {
    return list.reduce( (acc, obj) => {
        var key = obj[field]            
        
        if(!acc[key]){
            acc[key] = 0;
        }
        acc[key] ++;
        return acc;
    }, {});
}
export const count = (list) => {
    return list.reduce( (acc, obj) => {
        
        if(!acc[obj]){
            acc[obj] = 0;
        }
        acc[obj] ++;
        return acc;
    }, {});
}
export const getLimitDate = (period, fullYear = new Date().getFullYear()) => {
    let dateLimit = Date.now() - oneWeek
    switch (period) {
        case "week":
            dateLimit = Date.now() - oneWeek
            break;
        case "month":
            dateLimit = Date.now() - oneMonth
            break;
        case "year":
            dateLimit = new Date(fullYear, 0, 1)
            break;
        default:
            break;
    }
    return dateLimit
}
export const getDateLabels = (period, fullYear = new Date().getFullYear()) => {
    let dateLabels = []
    
    if (period === "year") {
        for(let i = 0; i < 12; i ++ ){
            dateLabels.push(Months[i] +" "+ fullYear) 
        }
    } else {
        let dateLimit = getLimitDate(period)
        for(let i = dateLimit; i < Date.now(); i += oneDay ){
            dateLabels.push(new Date(i).toLocaleDateString("fr-FR") ) 
        }
    }
    return dateLabels
}

